import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  TextField,
  MenuItem,
  Button,
  IconButton,
  CircularProgress,
  Box,
  Chip
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import AddCustomHours from "../../Adding/addHOP/customhours";
import { axiosInstance } from "../../../services/axiosInstance";
import { endpoints } from "../../../services/endpoint";
import "./edithours.css";
import CloseIcon from "@mui/icons-material/Close";
const EditHoursPage = ({
  hour, // ✅ selected HOP to edit
  onClose,
  onUpdate, 
}) => {
  const [newName, setNewName] = useState(hour.name || "");
  const [description, setDescription] = useState(hour.description || "");
  const [timeZone, setTimeZone] = useState(hour.timeZone || "");
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [customHours, setCustomHours] = useState(null);
  const [showTags, setShowTags] = useState(false);
  const [errors, setErrors] = useState({});
  const [saveLoader, setSaveLoader] = useState(false);
  const [cancelButtonLoading, setCancelButtonLoading] = useState(false);
const [actionClicked, setActionClicked] = useState(null); 
  const instanceAlias = localStorage.getItem("instanceName");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
  const instanceId = localStorage.getItem("InstanceId");
  const accessurl = localStorage.getItem("selctedurl");
  const id = hour.id || hour.arn;
  const accountNo = customerAWSAccountId;
 const EncryptedInstanceId=localStorage.getItem("EncryptedId");
   const email = localStorage.getItem("Email");
     const username = localStorage.getItem("username");
  // ✅ Initialize custom hours from existing config
  useEffect(() => {
    console.log("Hour object received:", hour);
    console.log("Hour config:", hour.config);
    
    // Initialize customHours with existing config if available
    if (hour.config && typeof hour.config === 'object') {
      // If config is already in the expected format (days as keys)
      if (hour.config.SUNDAY || hour.config.MONDAY) {
        setCustomHours(hour.config);
      } else {
        // If config is an array of day objects, convert it
        setCustomHours(hour.config);
      }
    } else {
      // Initialize with empty structure
      setCustomHours(null);
    }
  }, [hour]);

  const handleCustomHoursChange = (updatedHours) => {
    console.log("Custom hours updated:", updatedHours);
    setCustomHours(updatedHours);
  };

  // ✅ Fetch timezone list on mount
  useEffect(() => {
    fetchTimeZones();
  }, []);

  const fetchTimeZones = async () => {
    try {
      const res = await axiosInstance.get(endpoints.addhop.timezoneslist);
      if (Array.isArray(res.data)) {
        setTimeZoneList(res.data);
      }
    } catch (err) {
      console.error("Error fetching timezones:", err);
    }
  };

  const toggleTagsDisplay = () => setShowTags((prev) => !prev);

  // ✅ Validate before save
  const validate = () => {
    let tempErrors = {};
    if (!newName.trim()) tempErrors.Name = "Name is required";
    if (!timeZone) tempErrors.timeZone = "Time zone is required";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // ✅ Fetch latest Hours after updating
  const fetchHoursOfOperation = async () => {
  const payload = {
    InstanceAlias: instanceAlias,
    awsAccount: customerAWSAccountId,
    region,
    ID: EncryptedInstanceId,
  };

  try {
    const response = await axiosInstance.post(
      endpoints.displaylisthop.dipslayhopdata,
      payload
    );

    if (!response.data?.body) {
      console.warn("⚠️ No body in API response");
      return;
    }

    // ✅ Parse body (ARRAY, not object)
    const parsedBody =
      typeof response.data.body === "string"
        ? JSON.parse(response.data.body)
        : response.data.body;

    if (!Array.isArray(parsedBody)) {
      console.warn("⚠️ Body is not an array");
      return;
    }

    const updatedList = parsedBody.map((item) => {
      // ✅ Normalize tags into readable format
      let tagsFormatted = "No tags";
      if (
        item.Tags &&
        typeof item.Tags === "string" &&
        item.Tags.trim() !== "-" &&
        item.Tags.trim() !== ""
      ) {
        tagsFormatted = item.Tags;
      } else if (item.Tags && typeof item.Tags === "object") {
        tagsFormatted = Object.entries(item.Tags)
          .map(([k, v]) => `${k}: ${v}`)
          .join(", ");
      }

      return {
        id: item.Arn, // ✅ ARN instead of HOPId
        name: item.Name,
        description: item.Description || "No description",
        tags: tagsFormatted,
        timeZone: item.TimeZone || "No timezone",
        config: item.Config || [],
        lastModifiedTime: item.LastModifiedTime || "No modification time",
      };
    });

    console.log("✅ Updated Hours of Operation List:", updatedList);

    onUpdate(updatedList); // ✅ Send updated list to parent
  } catch (error) {
    console.error("❌ Error fetching updated hours:", error);
  }
};


  // ✅ Save updated HOP
  const handleSave = async () => {
    if (!validate()) return;
setActionClicked("save");
    setSaveLoader(true);

    const requestPayload = {
      action: "update",
      OldName: hour.name,
      NewName: newName,
      description,
      timezone: timeZone,
      timeSlots: customHours,
      accessurl,
      ID: EncryptedInstanceId,
      Email:email,
      UserName:username,
      InstanceAlias:instanceAlias,
      region,
      awsAccount: accountNo,
    };

    console.log("Editing HOP payload:", requestPayload);

    try {
      const response = await axiosInstance.post(
        endpoints.addhours.addhop,
        requestPayload
      );

      if (response.status === 200) {
        console.log("✅ Hours updated successfully:", response.data);
        await fetchHoursOfOperation();
      } else {
        console.error("Unexpected response while updating:", response);
      }
    } catch (error) {
      console.error("Error updating hours:", error);
    } finally {
      setSaveLoader(false);
      setActionClicked(null);
    }
  };

  // ✅ Cancel & go back to table without changes
  const handleCancel = async () => {
    setActionClicked("cancel");
    setCancelButtonLoading(true);
    setTimeout(() => {
      setCancelButtonLoading(false);
      setActionClicked(null);
      onClose();
    }, 300);
  };

  return (
       <div className="addhour-navbar-container">
         <Container className="addhour-content-container">
      <Box display="flex" flexDirection="column" alignItems="flex-start" mb={1} gap={1}>
 
  <IconButton
    onClick={onClose}
    size="medium"
    sx={{
      border: "1px solid #ccc",       // border color
      borderRadius: "50%",            // makes it circular
      padding: 1,                     // inner spacing
      bgcolor: "#f5f5f5",             // background color
      "&:hover": { bgcolor: "#e0e0e0" } // hover effect
    }}
  >
    <ArrowBackIcon />
  </IconButton>
      
        <Typography variant="h4" className="phone-text"> Edit {hour.name}</Typography>
        </Box>
        
      {/* Hours of Operation Form */}
      <div className="form-section">
       
        <div className="edithour-form-fields">
          <TextField
            label="Name"
           placeholder="Enter Name"
            required
            className="edithour-form-field"
            helperText={errors.Name}
            error={!!errors.Name}
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
          />
          <TextField
            label="Description"
           placeholder="Enter description"
            className="edithour-form-field"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <TextField
            label="Select time zone"
            placeholder="selct time zone"
            required
            select
            className="edithour-form-field"
            value={timeZone}
            onChange={(e) => setTimeZone(e.target.value)}
          >
            {timeZoneList.length > 0 ? (
              timeZoneList.map((timezone, index) => (
                <MenuItem key={index} value={timezone}>
                  {timezone}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No time zones available</MenuItem>
            )}
          </TextField>
        </div>
      </div>

      {/* Settings */}
      <div className="edithour-setting-section">
        <h3>Settings</h3>
        <AddCustomHours
          setCustomHours={handleCustomHoursChange}
          setCustomHoursData={handleCustomHoursChange}
          initialData={hour.config} // ✅ Pass the existing config as initial data
          customHours={customHours}
        />

        {/* Advanced Settings */}
        <Box className="edithour-tags-container">
          <Box className="edithourtagsdisplayingstyle" onClick={toggleTagsDisplay}>
            <Typography variant="h6" className="showadvancetext">
              Show advanced settings
            </Typography>
            <IconButton size="small">
              {showTags ? (
                <ArrowDropUpIcon className="arrowstyling-tagsshow" />
              ) : (
                <ArrowDropDownIcon className="arrowstyling-tagsshow" />
              )}
            </IconButton>
          </Box>

         {showTags && (
  <Box mt={1}>
    {/* <Typography className="selectedtagsdisplaying">
      Selected Tags
    </Typography> */}

    {hour.tags && hour.tags.length > 0 ? (
      <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
        {hour.tags.map((tag, idx) => (
          <Chip
            key={idx}
            label={`${tag.key}: ${tag.value}`}
            size="small"
            sx={{ m: 0.3 }}
          />
        ))}
      </Box>
    ) : (
      <Typography variant="body1" color="textSecondary">
        No tags
      </Typography>
    )}
  </Box>
)}

        </Box>
      </div>

      {/* Buttons */}
      <div className="buttons-addhour">
        <Button
          onClick={handleCancel}
            disabled={actionClicked === "save" || cancelButtonLoading}
               >
                 <span className="adduser-button-content">
                   {actionClicked === "cancel" ? (
                     <CircularProgress size={18} style={{ color: "red" }} />
                   ) : (
                     "Cancel"
                   )}
                           </span>
        </Button>
        <Button
          onClick={handleSave}
           variant="contained"
                        disabled={actionClicked === "cancel" || saveLoader}
                >
                  <span className="adduser-button-content">
                    {actionClicked === "save" ? (
                      <CircularProgress size={18} style={{ color: "white" }} />
                    ) : (
                      "Save"
                    )}
                            </span>
        </Button>
      </div>
    </Container>
    </div>
  );
};

export default EditHoursPage;